import { PredefinedPhrasesFormValues } from '../Components/PredefinedPhrasesDiscourse/PredefinedPhrasesDiscoursePhraseForm';
import { PredefineDiscoursePhrase } from '../Components/PredefinedPhrasesDiscourse/PredefinedPhrasesDiscourseSetup';

export const prepareDocumentDataChildren = (
	values: PredefinedPhrasesFormValues,
) => {
	const children: { type: string; extra: object }[] = [];
	if (values.text) {
		children.push({
			type: 'content',
			extra: {
				text: values.text,
			},
		});
	}
	if (values.name) {
		children.push({
			type: 'name',
			extra: {
				text: values.name,
			},
		});
	}
	if (values.diagnosis) {
		children.push({
			type: 'diagnosis',
			extra: {
				subType: 'main_diagnosis',
				text: values.diagnosis,
			},
		});
	}
	if (values.diagnoses && values.diagnoses.length > 0) {
		values.diagnoses.forEach(item => {
			children.push({
				type: 'diagnosis',
				extra: {
					subType: 'secondary_diagnosis',
					text: item.secondaryDiagnosis,
				},
			});
		});
	}
	return children;
};

export const getLabel = (
	item: PredefineDiscoursePhrase,
): string | undefined => {
	const name = item.items.find(i => i.type === 'name');
	if (name) {
		if (typeof name.extra.text === 'string') {
			return name.extra.text;
		}
	}
	const text = item.items.find(i => i.type === 'content');
	if (text) {
		if (typeof text.extra.text === 'string') {
			return text.extra.text;
		}
	}
	return undefined;
};
